import { FiBriefcase, FiAward, FiTrendingUp, FiTarget, FiActivity, FiUsers, FiCheckCircle, FiBookOpen, FiMic, FiCalendar, FiClock, FiStar, FiZap, FiGlobe, FiPlusCircle } from 'react-icons/fi';

export const shopCategories = [
  { id: 'single', name: 'Clase Individual', icon: FiUsers },
  { id: 'packages', name: 'Paquetes Mensuales', icon: FiTrendingUp },
  { id: 'specialized', name: 'Especialidades', icon: FiAward },
  { id: 'group', name: 'Salas de Grupo 24/7', icon: FiBookOpen }
];

export const shopProducts = [
  // CATEGORY: CLASE INDIVIDUAL
  {
    id: 'clase-individual',
    slug: 'clase-individual-ingles-nativos',
    category: 'single',
    title: 'Clase Individual',
    subtitle: 'Lección 1-a-1 de 50 minutos con profesor certificado nativo',
    priceUsd: 10,
    priceMxn: 175,
    period: 'por clase (50 min)',
    level: 'MÁS POPULAR',
    xp: '50 MINUTOS',
    stripeUrl: 'https://buy.stripe.com/4gM5kw2qMcmr1eCcEtc3m0h',
    description: 'Atención 100% personalizada con enfoque en tus objetivos específicos, ya sean profesionales o académicos.',
    icon: FiUsers,
    features: [
      'Profesor nativo certificado',
      'Corrección de pronunciación en vivo',
      'Gramática contrastiva (inglés-español)',
      'Planes de estudio personalizados',
      'Feedback escrito después de clase',
      'Acceso a salas de práctica 24/7'
    ],
    salesContent: {
      headline: "Tu Progreso a tu Propio Ritmo",
      subheadline: "La forma más rápida de eliminar vicios del lenguaje y ganar confianza total.",
      innovation: "Algoritmo de emparejamiento que te asigna al tutor ideal según tu industria.",
      outcomes: ["Fluidez espontánea", "Acento neutralizado", "Confianza en juntas"],
      impact: "Incremento del 40% en participación activa en reuniones bilingües."
    }
  },
  {
    id: 'clase-especialidad',
    slug: 'clase-especialidad-business-ielts',
    category: 'single',
    title: 'Clase de Especialidad',
    subtitle: 'Enfoque personalizado: IELTS, TOEFL, Business, Pronunciación',
    priceUsd: 12,
    priceMxn: 210,
    period: 'por clase (50 min)',
    level: 'ELITE',
    xp: 'PRO CONTENT',
    stripeUrl: 'https://buy.stripe.com/dRm4gsd5qaej9L8gUJc3m0g',
    description: 'Sesiones avanzadas enfocadas en objetivos técnicos y profesionales de alto nivel.',
    icon: FiStar,
    features: [
      'Profesor especializado en tu tema',
      'Materiales específicos del examen',
      'Simulacros de prueba completos',
      'Estrategias probadas para puntuación alta',
      'Feedback de experto en modalidad'
    ],
    salesContent: {
      headline: "Domina el Inglés Técnico",
      subheadline: "Prepárate con expertos que han ayudado a miles a certificar su nivel.",
      innovation: "Simuladores de exámenes oficiales integrados en la videollamada.",
      outcomes: ["Puntaje objetivo IELTS/TOEFL", "Vocabulario técnico", "Estrategia de examen"],
      impact: "98% de nuestros estudiantes logran su puntaje deseado en el primer intento."
    }
  },
  {
    id: 'clinica-gramatica',
    slug: 'clinica-gramatica-intensiva',
    category: 'single',
    title: 'Clínica de Gramática',
    subtitle: 'Sesión enfocada en tus errores específicos (30 min)',
    priceUsd: 6,
    priceMxn: 105,
    period: 'por sesión (30 min)',
    level: 'RECOMENDADO',
    xp: 'FOCUS',
    stripeUrl: 'https://buy.stripe.com/fZu4gsaXi2LRbTg8odc3m0f',
    description: 'Resuelve dudas puntuales y corrige vicios del lenguaje en sesiones cortas y efectivas.',
    icon: FiActivity,
    features: [
      'Sesión de 30 minutos enfocada',
      'Análisis de errores personalizados',
      'Patrones de errores identificados',
      'Referencia rápida descargable'
    ],
    salesContent: {
      headline: "Precisión Quirúrgica en tu Inglés",
      subheadline: "Elimina esos errores repetitivos que afectan tu credibilidad profesional.",
      innovation: "Análisis de patrones de error mediante IA diagnóstica.",
      outcomes: ["Escritura impecable", "Estructuras complejas", "Claridad gramatical"],
      impact: "Reducción del 70% en errores comunes de redacción en 4 sesiones."
    }
  },

  // CATEGORY: PAQUETES MENSUALES
  {
    id: 'plan-iniciador',
    slug: 'plan-iniciador-ingles',
    category: 'packages',
    title: 'Plan Iniciador',
    subtitle: 'Perfecto para empezar tu viaje al inglés',
    priceUsd: 80,
    priceMxn: 1400,
    period: '8 clases/mes',
    level: 'BÁSICO',
    xp: 'STARTER',
    stripeUrl: 'https://buy.stripe.com/dRm9AM7L64TZf5scEtc3m0e',
    description: 'La mejor forma de crear el hábito de estudio con flexibilidad total.',
    icon: FiZap,
    features: [
      '8 clases individuales de 50 min',
      '2 clases por semana (flexible)',
      'Profesor asignado para continuidad',
      'Acceso completo a salas 24/7'
    ],
    salesContent: {
      headline: "El Hábito que Cambiará tu Vida",
      subheadline: "Inicia con una base sólida y constante. Ideal para profesionales ocupados.",
      innovation: "Sistema de continuidad pedagógica entre profesores.",
      outcomes: ["Base gramatical sólida", "Ritmo de aprendizaje constante", "Primeros certificados"],
      impact: "Consolidación del nivel A1/A2 en menos de 3 meses."
    }
  },
  {
    id: 'plan-avance',
    slug: 'plan-avance-popular',
    category: 'packages',
    title: 'Plan Avance',
    subtitle: 'El más popular - Mejor balance de precio y frecuencia',
    priceUsd: 140,
    priceMxn: 2450,
    period: '16 clases/mes',
    level: 'RECOMENDADO',
    xp: 'POPULAR',
    stripeUrl: 'https://buy.stripe.com/aFa9AM0iE9af3mKawlc3m0c',
    description: 'Acelera tu aprendizaje con una frecuencia ideal para la retención.',
    icon: FiTrendingUp,
    features: [
      '16 clases individuales de 50 min',
      '4 clases por semana',
      '2 clínicas de gramática/mes incluidas',
      'Prioridad de agendamiento'
    ],
    salesContent: {
      headline: "Resultados Visibles Mes a Mes",
      subheadline: "Nuestro programa estrella diseñado para quienes necesitan hablar ya.",
      innovation: "Ruta de aprendizaje adaptativa basada en desempeño semanal.",
      outcomes: ["Conversación fluida", "Comprensión auditiva alta", "Vocabulario social"],
      impact: "Salto de nivel (ej. B1 a B2) garantizado en 6 meses de uso constante."
    }
  },
  {
    id: 'plan-intensivo',
    slug: 'plan-intensivo-acelerado',
    category: 'packages',
    title: 'Plan Intensivo',
    subtitle: 'Para estudiantes altamente comprometidos',
    priceUsd: 240,
    priceMxn: 4200,
    period: '24 clases/mes',
    level: 'LEGENDARIO',
    xp: 'FAST TRACK',
    stripeUrl: 'https://buy.stripe.com/5kQ00c8PagCH3mK9shc3m0b',
    description: 'Inmersión casi total para quienes necesitan resultados inmediatos.',
    icon: FiTarget,
    features: [
      '24 clases individuales de 50 min',
      '6 clases por semana',
      'Sesiones de especialidad 2x/mes',
      'Soporte VIP prioritario'
    ],
    salesContent: {
      headline: "Inmersión Total Sin Salir de Casa",
      subheadline: "Para metas agresivas como mudarse al extranjero o un ascenso inminente.",
      innovation: "Célula de profesores dedicada (3-a-1) para diversidad de acentos.",
      outcomes: ["Dominio avanzado", "Pensamiento en inglés", "Cero barreras"],
      impact: "Equivalente a vivir 6 meses en un país de habla inglesa."
    }
  },
  {
    id: 'plan-maxima',
    slug: 'plan-maxima-inmersion',
    category: 'packages',
    title: 'Plan Máxima Inmersión',
    subtitle: 'Para lograr fluidez en tiempo récord',
    priceUsd: 320,
    priceMxn: 5600,
    period: '32 clases/mes',
    level: 'ULTIMATE',
    xp: 'FULL POWER',
    stripeUrl: 'https://buy.stripe.com/7sYcMY8PafyD4qO7k9c3m0a',
    description: 'El programa más robusto del campus para dominio total.',
    icon: FiPlusCircle,
    features: [
      '32 clases individuales de 50 min',
      'Hasta 8 clases por semana',
      'Especialidades ilimitadas',
      'Coach de carrera incluido'
    ],
    salesContent: {
      headline: "La Máxima Experiencia Educativa",
      subheadline: "Acceso ilimitado a todos los recursos del campus con prioridad VIP.",
      innovation: "Coach de carrera bilingüe incluido para optimización de perfil.",
      outcomes: ["Fluidez nativa", "Liderazgo bilingüe", "Acceso total"],
      impact: "Transformación radical del perfil profesional en 90 días."
    }
  },

  // CATEGORY: ESPECIALIDADES
  {
    id: 'ielts-masterclass',
    slug: 'ielts-masterclass-prep',
    category: 'specialized',
    title: 'IELTS Masterclass',
    subtitle: 'Preparación completa para certificación IELTS',
    priceUsd: 200,
    priceMxn: 3500,
    period: '4 semanas (10 clases)',
    level: 'CERTIFICACIÓN',
    xp: 'POPULAR',
    stripeUrl: 'https://buy.stripe.com/28EaEQ2qM0DJ5uS7k9c3m09',
    description: 'Estrategias probadas para maximizar tu puntaje en el examen oficial.',
    icon: FiAward,
    features: [
      '10 clases especializadas en IELTS',
      '4 simulacros de examen completo',
      'Estrategias por sección',
      'Acceso a banco de preguntas'
    ],
    salesContent: {
      headline: "Tu Pasaporte al Mundo",
      subheadline: "No solo aprendas inglés, aprende a ganar el examen IELTS.",
      innovation: "Metodología de 'Reverse Engineering' para tipos de preguntas.",
      outcomes: ["Band 7.0+ Garantizado", "Técnicas de Reading rápido", "Writing estructurado"],
      impact: "Promedio de mejora de 1.5 puntos en la banda general en 4 semanas."
    }
  },
  {
    id: 'toefl-express',
    slug: 'toefl-ibt-express',
    category: 'specialized',
    title: 'TOEFL iBT Express',
    subtitle: 'Ruta rápida a tu puntuación TOEFL objetivo',
    priceUsd: 220,
    priceMxn: 3850,
    period: '6 semanas (12 clases)',
    level: 'ELITE',
    xp: 'ACADEMIC',
    stripeUrl: 'https://buy.stripe.com/eVq4gs6H20DJ1eCfQFc3m08',
    description: 'Foco intensivo en las habilidades académicas requeridas por el TOEFL.',
    icon: FiGlobe,
    features: [
      '12 clases TOEFL intensivas',
      '5 simulacros con puntuación oficial',
      'Dominio de integrated tasks',
      'Acceso a plataforma oficial ETS'
    ],
    salesContent: {
      headline: "Éxito Académico Internacional",
      subheadline: "Especializado en el formato iBT para admisiones universitarias.",
      innovation: "Feedback grabado sobre tus simulacros de Speaking.",
      outcomes: ["100+ puntos TOEFL", "Habilidad de síntesis", "Escucha académica"],
      impact: "Acceso a becas internacionales mediante puntajes competitivos."
    }
  },
  {
    id: 'business-pro',
    slug: 'business-english-pro',
    category: 'specialized',
    title: 'Business English Pro',
    subtitle: 'Domina inglés profesional y reuniones corporativas',
    priceUsd: 160,
    priceMxn: 2800,
    period: '8 semanas (12 clases)',
    level: 'PROFESIONAL',
    xp: 'CORPORATE',
    stripeUrl: 'https://buy.stripe.com/8x26oAghC86b2iGeMBc3m07',
    description: 'Vocabulario y etiqueta de negocios para el mundo real.',
    icon: FiBriefcase,
    features: [
      '12 clases de inglés empresarial',
      'Simulaciones de reuniones reales',
      'Presentaciones ejecutivas',
      'Email profesional efectivo'
    ],
    salesContent: {
      headline: "Lidera en el Mercado Global",
      subheadline: "Deja de traducir en tu mente y empieza a negociar con impacto.",
      innovation: "Role-plays basados en casos reales de tu industria específica.",
      outcomes: ["Presentaciones potentes", "Networking efectivo", "Emails profesionales"],
      impact: "Aumento en la efectividad de negociaciones internacionales reportada por alumnos."
    }
  },
  {
    id: 'pronunciacion-perfecta',
    slug: 'pronunciacion-perfecta-lab',
    category: 'specialized',
    title: 'Pronunciación Perfecta',
    subtitle: 'Domina los 12 sonidos vocálicos del inglés',
    priceUsd: 90,
    priceMxn: 1575,
    period: '4 semanas (6 clases)',
    level: 'HABILIDAD',
    xp: 'PHONETICS',
    stripeUrl: 'https://buy.stripe.com/4gMdR24yUcmre1o0VLc3m06',
    description: 'Neutraliza tu acento y habla con la claridad de un nativo.',
    icon: FiMic,
    features: [
      '6 clases de pronunciación intensivas',
      'Fonética articulatoria avanzada',
      'Práctica de entonación y ritmo',
      'Acceso a laboratorio de voz'
    ],
    salesContent: {
      headline: "Habla con Claridad y Elegancia",
      subheadline: "La llave para que te entiendan a la primera, siempre.",
      innovation: "Entrenamiento muscular facial para sonidos no existentes en español.",
      outcomes: ["Acento reducido", "Entonación natural", "Fluidez fonética"],
      impact: "Eliminación del 80% de las repeticiones por falta de claridad en 30 días."
    }
  },

  // CATEGORY: SALAS DE GRUPO
  {
    id: 'salas-abiertas',
    slug: 'salas-conversacion-abiertas',
    category: 'group',
    title: 'Salas de Conversación Abiertas',
    subtitle: 'Práctica grupal GRATUITA 24/7 sin profesor fijo',
    priceUsd: 0,
    priceMxn: 0,
    period: 'Acceso Estudiante',
    level: 'MÁS VALOR',
    xp: 'COMMUNITY',
    stripeUrl: null,
    description: 'El corazón del campus. Habla con personas de todo México en cualquier momento.',
    icon: FiUsers,
    features: [
      'Acceso ilimitado 24 horas x 7 días',
      'Salas por nivel (A1 a C1)',
      'Disponible en app móvil',
      'Sin presión, ambiente amigable'
    ],
    salesContent: {
      headline: "Tu Gimnasio de Inglés 24/7",
      subheadline: "La práctica hace al maestro. Entra y sal cuando quieras.",
      innovation: "Lobby social con gamificación por tiempo de habla.",
      outcomes: ["Confianza social", "Escucha activa", "Amigos globales"],
      impact: "Estudiantes que usan las salas 15 min/día avanzan 2x más rápido."
    }
  },
  {
    id: 'salas-premium',
    slug: 'salas-conversacion-premium',
    category: 'group',
    title: 'Salas de Conversación Premium',
    subtitle: 'Grupos pequeños (máx 5 personas) con profesor',
    priceUsd: 30,
    priceMxn: 525,
    period: 'por mes (ilimitadas)',
    level: 'PREMIUM',
    xp: 'ELITE GROUP',
    stripeUrl: 'https://buy.stripe.com/cNibIU8Pa0DJ8H48odc3m05',
    description: 'Práctica guiada por expertos en grupos ultra-reducidos.',
    icon: FiStar,
    features: [
      'Acceso a salas premium 24/7',
      'Máximo 5 estudiantes por sala',
      'Profesor certificado presente',
      'Feedback personalizado'
    ],
    salesContent: {
      headline: "Feedback Experto en Grupo",
      subheadline: "Lo mejor de la clase privada con la dinámica de una charla real.",
      innovation: "Reporte de participación individual después de cada sesión.",
      outcomes: ["Corrección inmediata", "Debate avanzado", "Seguimiento experto"],
      impact: "Ideal para mantener fluidez después de terminar programas intensivos."
    }
  },
  {
    id: 'club-lectura',
    slug: 'club-lectura-ingles',
    category: 'group',
    title: 'Club de Lectura en Inglés',
    subtitle: 'Mejora comprensión de lectura + debate intelectual',
    priceUsd: 40,
    priceMxn: 700,
    period: 'por mes (2 sesiones/semana)',
    level: 'CULTURAL',
    xp: 'LITERARY',
    stripeUrl: 'https://buy.stripe.com/aFa8wI6H2gCH3mK1ZPc3m04',
    description: 'Analiza literatura y expande tu vocabulario culto.',
    icon: FiBookOpen,
    features: [
      '8 sesiones por mes (2 x semana)',
      'Libros graduados por nivel',
      'Materiales y glosarios incluidos',
      'Análisis de expresiones idiomáticas'
    ],
    salesContent: {
      headline: "Inglés de Alto Nivel",
      subheadline: "Para quienes buscan un vocabulario sofisticado y pensamiento crítico.",
      innovation: "Biblioteca digital curada integrada al campus.",
      outcomes: ["Vocabulario culto", "Comprensión lectora", "Análisis crítico"],
      impact: "Aumento del 300% en vocabulario pasivo en solo 2 meses."
    }
  }
];

export const specialties = [
  { title: "Inglés de Negocios", desc: "Domina el lenguaje corporativo para liderar juntas y negociaciones.", icon: FiBriefcase, color: "text-blue-500" },
  { title: "Preparación IELTS", desc: "Estrategias específicas para obtener el puntaje que necesitas para migrar.", icon: FiAward, color: "text-yellow-500" },
  { title: "Inglés Médico", desc: "Terminología técnica especializada para profesionales de la salud.", icon: FiActivity, color: "text-red-500" },
  { title: "Turismo y Viajes", desc: "Desenvuélvete con naturalidad en aeropuertos y hoteles de todo el mundo.", icon: FiGlobe, color: "text-green-500" }
];